import { NeoState } from '../Reducers.interface';

export const selectAvailablePaymentMethod = (state: NeoState) =>
  state.payments.paymentMethods.filter((method) => method.enabled);
